import axios from "axios";

export interface UserObject {
    photo_url: string;
    fullName: string;
}

export const updateProfile = (userObject: UserObject, onProfileSuccess: (message: string, userObject: UserObject) => void, onProfileFailure: (errMsg: string) => void) => {
    return async () => {

        await axios.patch('/admin/edit-admin-profile', userObject)
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    onProfileSuccess(response?.data?.message, userObject);
                } else {
                    onProfileFailure(response?.data?.message);
                }
            })
            .catch((err) => {
                onProfileFailure(err?.response?.data?.message)
            });
    }
}

